import { useEffect } from 'react';
import ModalRoot from '../components/ModalRoot';

// A page's own pop-up (Complete Driver Report, Cancel job, Merge, …) — the
// free-form sibling of BottomSheet for dialogs that bring their own title
// and layout. Renders through ModalRoot, so it sits ABOVE the top bar and
// the phone tab bar (both hidden while it is open) instead of being trapped
// under them. On a phone it is a bottom sheet sized to the visible screen
// (dvh, not vh — Safari's toolbars eat vh) that scrolls; the row marked
// `.m-dialog-actions` stays pinned to the bottom so Save is always reachable.
// On desktop it is the familiar centered card.
export default function Dialog({ onClose, busy, maxWidth = 520, children, style }) {
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape' && !busy) onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, busy]);
  return (
    <ModalRoot className="m-dialog-overlay" onClick={() => !busy && onClose?.()}>
      <div className="m-dialog" role="dialog" aria-modal="true" style={{ maxWidth, ...style }}
        onClick={e => e.stopPropagation()}>
        {children}
      </div>
    </ModalRoot>
  );
}
